import SearchWithFilters from '~/components/search-with-filters/search-with-filters.vue';
const ModelHistory = defineAsyncComponent(
  () => import('~/components/model-history/ModelHistory.vue')
);

export default defineComponent({
  name: 'Search',
  components: {
    ModelHistory,
    SearchWithFilters,
  },
  setup() {
    const route = useRoute();
    definePageMeta({
      middleware: function (to) {
        if (!to?.query?.query) return navigateTo('/catalog/');
      },
    });
    useHead(() => {
      const meta = [
        {
          hid: 'description',
          name: 'description',
          content: `Поиск ${route.query.query || ''} на Price.ru`,
        },
        {
          property: 'og:title',
          content: `Поиск ${route.query.query || ''} на Price.ru`,
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex, nofollow',
        },
      ];
      return {
        title: `Поиск ${route.query.query || ''} на Price.ru`,
        meta,
      };
    });
  },
});
